<template>
  <div>
    <div class="mb-2">
      <v-layout align-center wrap class="my-4">
        <v-flex sm6 md3 class="pr-2">
          <div class="caption">Group</div>
          <multiselect
            v-model="filterAgentGroup"
            :options="agentGroupOptions"
            select-label
            selected-label
            :allow-empty="true"
            :searchable="true"
            deselect-label
            label="groupname"
            placeholder="select group"
            :disabled="isAgent"
            @input="handleFetchData()"
          ></multiselect>
        </v-flex>
        <v-flex sm6 md3 class="pl-2">
          <div class="caption">Agent</div>
          <multiselect
            v-model="filterAgent"
            :options="agentOptions"
            select-label
            selected-label
            :allow-empty="true"
            :searchable="true"
            deselect-label
            @input="handleFetchData()"
          ></multiselect>
        </v-flex>
        <v-flex sm12 md6 style="display: flex" class="justify-end">
          <v-btn outline color="primary" class="ma-0 mb-1" @click="handleExport">
            <em class="fas fa-file-export mr-1" />
            {{ $t('export') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </div>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      class="elevation-1"
      :pagination.sync="pagination"
      hide-actions
    >
      <template #items="props">
        <tr style="cursor: pointer" @click="handleToggleDialogCheckinTimeTable(true, props.item)">
          <td>{{ props.item.name }}</td>
          <td class="text-xs-right">{{ props.item.pending }}</td>
          <td class="text-xs-right">{{ props.item.answered }}</td>
          <template v-if="selectedBot.unlock_survey">
            <td class="text-xs-right">{{ props.item.close_with_survey }}</td>
          </template>
          <td class="text-xs-right">{{ props.item.close_without_survey }}</td>
          <td class="text-xs-right">{{ props.item.transfer }}</td>
          <td class="text-xs-right" style="white-space: nowrap">
            {{
              props.item.first_time && props.item.totalFirstResponseTicket
                ? formatAvg(props.item.first_time / props.item.totalFirstResponseTicket)
                : formatAvg(0)
            }}
          </td>
          <td class="text-xs-right" style="white-space: nowrap">
            {{
              props.item.close_time && props.item.closed
                ? formatAvg(props.item.close_time / props.item.closed)
                : formatAvg(0)
            }}
          </td>
          <td class="text-xs-right">{{ props.item.total_sl }}</td>
          <td class="text-xs-right">{{ props.item.total_over_sl }}</td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog v-model="showCheckinTimeTable" width="800px" persistent>
      <template v-if="showCheckinTimeTable">
        <dialog-agent
          :dialogdata="currentAgent"
          :selected-date="selectedDate"
          @close="handleToggleDialogCheckinTimeTable(false, null)"
        ></dialog-agent>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ticket3AgentManagementApi from '@/api/ticket3/agent-management'
import dayjs from 'dayjs'
import { DATETIME } from '@/constants/datetime'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import XLSX from 'xlsx'
import DialogAgent from './DialogAgent.vue'

export default {
  components: {
    Multiselect,
    DialogAgent
  },
  filters: {
    timer(value) {
      const hours = Math.floor(value / 60 / 60) % 60
      const minutes = Math.floor(value / 60) % 60
      const seconds = value % 60
      const padZero = (number) => number.toString().padStart(2, '0')
      return `${padZero(hours)}h ${padZero(minutes)}m ${padZero(seconds)}s`
    }
  },
  props: {
    selectedDate: {
      type: Object,
      default: () => ({
        end: dayjs().format('YYYY-MM-DD'),
        start: dayjs().subtract(7, 'days').format('YYYY-MM-DD')
      })
    }
  },
  data() {
    return {
      items: [],
      loading: false,
      filterAgent: '',
      filterAgentGroup: { groupname: 'All', id: '' },
      pagination: { rowsPerPage: -1, sortBy: '' },
      localPagination: {
        page: 1,
        totalItems: 0,
        rowsPerPage: 10,
        ...this.pagination
      },
      showCheckinTimeTable: false,
      currentAgent: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    headers() {
      const headers = [
        { text: 'Agent', value: 'agent', sortable: false },
        { text: 'Pending', value: 'pending', align: 'center', sortable: false },
        { text: 'Answered', value: 'answered', align: 'center', sortable: false },
        ...(this.selectedBot.unlock_survey
          ? [
              {
                text: 'Closed with survey',
                value: 'close_with_survey',
                align: 'center',
                sortable: false
              }
            ]
          : []),
        {
          text: this.selectedBot.unlock_survey ? 'Closed without survey' : 'Closed',
          value: 'close_without_survey',
          align: 'center',
          sortable: false
        },
        { text: 'Tickets transfer', value: 'transfer', align: 'center', sortable: false },
        {
          text: 'AVG first response time',
          value: 'first_time',
          align: 'right',
          sortable: false
        },
        {
          text: 'AVG resolved ticket time',
          value: 'close_time',
          align: 'right',
          sortable: false
        },
        {
          text: 'Closed case within SLA',
          value: 'total_sl',
          align: 'center',
          sortable: false
        },
        { text: 'Closed case over SLA', value: 'total_over_sl', align: 'center', sortable: false }
      ]
      return headers
    },
    totalPages() {
      const { totalItems, rowsPerPage } = this.localPagination
      return Math.ceil(totalItems / rowsPerPage)
    },
    agentGroupList() {
      return this.$store.state.agentGroups
    },
    agentGroupOptions() {
      if (this.agentGroupList && this.agentGroupList.length > 0) {
        return [{ groupname: 'All', id: '' }, ...this.agentGroupList]
      }
      return [{ groupname: 'All', id: '' }]
    },
    agentList() {
      return this.$store.state.agents
    },
    agentOptions() {
      let options = []
      if (this.isAgent) {
        options = this.agentList
          .filter((agent) => agent.adminid === this.$store.state.userid)
          .map((el) => el.adminid)
      } else {
        options = this.agentList.map((el) => el.adminid)
      }
      return options
    },
    isAgent() {
      return this.$store.state.privilege && this.$store.state.privilege.role == 'agent'
    }
  },
  watch: {
    pagination(value) {
      this.localPagination = {
        page: 1,
        totalItems: 0,
        rowsPerPage: 10,
        ...value
      }
    },
    selectedDate: {
      handler() {
        this.handleFetchData()
      },
      deep: true
    }
  },
  mounted() {
    this.handleFetchData()
  },
  methods: {
    handleToggleDialogCheckinTimeTable(show, item) {
      this.currentAgent = item
      this.showCheckinTimeTable = show
    },
    async handleFetchData() {
      const vm = this
      try {
        if (this.isAgent) {
          vm.filterAgent = vm.$store.state.userid
        }

        vm.loading = true
        const responseData = await vm.getCountTicketStatusByAgent()

        if (responseData) {
          const result = vm.calculateTicket(responseData)
          vm.items = result
        }
        vm.loading = false
      } catch (error) {
        vm.loading = false
        console.error(error)
      }
    },
    async getCountTicketStatusByAgent() {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          start_date: dayjs(vm.selectedDate.start).format(DATETIME.DATE_FORMAT),
          end_date: dayjs(vm.selectedDate.end).format(DATETIME.DATE_FORMAT)
        }

        if (this.filterAgentGroup && this.filterAgentGroup.id) {
          Object.assign(data, { admin_group_id: this.filterAgentGroup.id })
        }
        if (this.filterAgent) {
          Object.assign(data, { admin_id: this.filterAgent })
        }

        const response = await ticket3AgentManagementApi.getCountTicketStatusByAgent({
          params: data
        })
        if (response && response.status === 200 && response.data) {
          return response.data.data
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    calculateTicket(data) {
      var list = {}
      var agents = []
      data.map((el) => {
        if (Object.hasOwnProperty.call(list, el.adminid)) {
          list[el.adminid].transfer += +(el.transferticket || 0)
          list[el.adminid].first_time += +(el.first_time || 0)
          list[el.adminid].close_time += +(el.close_time || 0)
          list[el.adminid].cold_case += parseInt(el.cold_case)
          list[el.adminid].total_sl += parseInt(el.sl)
          list[el.adminid].total_over_sl += parseInt(el.over_sl)
          list[el.adminid].all += parseInt(el.amount)
          list[el.adminid].totalticket += 1
          list[el.adminid].totalFirstResponseTicket += parseInt(el.amount)
          list[el.adminid].all += parseInt(el.amount)
          switch (el.status) {
            case 'pending':
              list[el.adminid].pending += parseInt(el.amount)
              break
            case 'answered':
              list[el.adminid].answered += parseInt(el.amount)
              break
            case 'closed':
              // list[el.adminid].closed += parseInt(el.amount)
              // list[el.adminid].averageclosetime = (
              //   parseFloat(el.close_time) / parseFloat(el.amount)
              // ).toFixed(2)
              break
            case 'cancelled':
              list[el.adminid].cancelled += parseInt(el.amount)
              break
            case 'cancelled by customer':
              list[el.adminid].cancelledbycustomer += parseInt(el.amount)
              break
            case 'closed with survey':
              list[el.adminid].close_with_survey += parseInt(el.amount)
              list[el.adminid].closed += parseInt(el.amount)
              list[el.adminid].averageclosetime = (
                parseFloat(el.close_time) / parseFloat(el.amount)
              ).toFixed(2)
              break
            case 'closed without survey':
              list[el.adminid].close_without_survey += parseInt(el.amount)
              list[el.adminid].closed += parseInt(el.amount)
              list[el.adminid].averageclosetime = (
                parseFloat(el.close_time) / parseFloat(el.amount)
              ).toFixed(2)
              break

            default:
              break
          }
        } else {
          list[el.adminid] = {
            adminid: el.adminid,
            name: el.name,
            all: parseInt(el.amount),
            pending: 0,
            closed: 0,
            cold_case: 0,
            answered: 0,
            cancelled: 0,
            cancelledbycustomer: 0,
            averageclosetime: 0,
            transfer: 0,
            first_time: 0,
            close_time: 0,
            total_sl: 0,
            total_over_sl: 0,
            totalticket: 0,
            totalFirstResponseTicket: 0,
            close_with_survey: 0,
            close_without_survey: 0
          }
          console.log(list[el.adminid])
          list[el.adminid].transfer += +(el.transferticket || 0)
          list[el.adminid].first_time += +(el.first_time || 0)
          list[el.adminid].close_time += +(el.close_time || 0)
          list[el.adminid].cold_case += parseInt(el.cold_case)
          list[el.adminid].total_sl += parseInt(el.sl)
          list[el.adminid].total_over_sl += parseInt(el.over_sl)
          list[el.adminid].totalticket += 1
          list[el.adminid].totalFirstResponseTicket += parseInt(el.amount)

          switch (el.status) {
            case 'pending':
              list[el.adminid].pending += parseInt(el.amount)
              break
            case 'closed':
              // list[el.adminid].closed += parseInt(el.amount)
              // list[el.adminid].averageclosetime = (
              //   parseFloat(el.close_time) / parseFloat(el.amount)
              // ).toFixed(2)
              break
            case 'answered':
              list[el.adminid].answered += parseInt(el.amount)
              break
            case 'cancelled':
              list[el.adminid].cancelled += parseInt(el.amount)
              break
            case 'cancelled by customer':
              list[el.adminid].cancelledbycustomer += parseInt(el.amount)
              break
            case 'closed with survey':
              list[el.adminid].close_with_survey += parseInt(el.amount)
              list[el.adminid].closed += parseInt(el.amount)
              list[el.adminid].averageclosetime = (
                parseFloat(el.close_time) / parseFloat(el.amount)
              ).toFixed(2)
              break
            case 'closed without survey':
              list[el.adminid].close_without_survey += parseInt(el.amount)
              list[el.adminid].closed += parseInt(el.amount)
              list[el.adminid].averageclosetime = (
                parseFloat(el.close_time) / parseFloat(el.amount)
              ).toFixed(2)
              break

            default:
              break
          }
        }
      })

      for (const key in list) {
        if (Object.hasOwnProperty.call(list, key)) {
          const element = list[key]
          agents.push(element)
        }
      }

      return agents
    },
    formatAvg(secs) {
      if (isNaN(secs)) return '0 ชั่วโมง 0 นาที 0 วินาที'
      const formatted = moment.utc(parseInt(secs) * 1000).format('H ชั่วโมง m นาที s วินาที')
      return formatted
    },

    async handleExport() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await vm.getCountTicketStatusByAgent()
        const responseData = vm.calculateTicket(response)

        if (responseData === null) {
          vm.$store.commit('CLEAR_LOADING')
          return
        }

        const data = responseData.map((el) => {
          return {
            agent: el.name,
            pending: el.pending,
            answered: el.answered,
            close_with_survey: el.close_with_survey,
            close_without_survey: el.close_without_survey,
            transfer: el.transfer,
            average_first_response_time: this.formatAvg(el.first_time / el.totalticket),
            average_resolved_ticket_time: this.formatAvg(el.close_time / el.closed),
            total_sl: el.total_sl,
            total_over_sl: el.total_over_sl,
            total: el.total_sl + el.total_over_sl
          }
        })

        const heading = [
          [
            'Agent',
            'Pending',
            'Answered',
            'Closed with survey',
            'Closed without survey',
            'Ticket transfer',
            'Average first response time',
            'Average resolved ticket time',
            'case within SL',
            'case over SL',
            'Total'
          ]
        ]
        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, data, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `agent-performance.xlsx`)
        vm.$store.commit('CLEAR_LOADING')
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/agents/Performance/DataTable.vue